import AntIcon from '@ant-design/icons';
import type { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

export const Icon = ({ component, className, style }: IconComponentProps) => (
  <AntIcon component={component} className={className} style={style} />
);
